import React, { useState } from "react";
import { auth } from "./firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import "./auth.css";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import { sendPasswordResetEmail } from "firebase/auth"
import { logEvent } from "firebase/analytics";
import { analytics } from "./analytics";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";



function AuthPage() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState("login"); // login | signup
  const [message, setMessage] = useState("");
  const [showReset, setShowReset] = useState(false)
  const [resetEmail, setResetEmail] = useState("")
  const navigate = useNavigate();

const handleSignup = async () => {
  try {
    setMessage("");

    const userCred = await createUserWithEmailAndPassword(auth, email, password);

    // Send verification email
    await sendEmailVerification(userCred.user);

    // Save user to Firestore
    await setDoc(doc(db, "users", userCred.user.uid), {
      email,
      username,
      createdAt: serverTimestamp(),
      isPro: false,
      rulesAccepted: false,
      progress: {
        resumesCreated: 0,
        resumeCritiques: 0,
        interviews: 0,
        communityPosts: 0
      }
    });

    // ✅ GOOGLE CONVERSION (safe check)
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-18133443644/WlnDCJmYt6YcELzI2cZD",
        value: 1.0,
        currency: "USD"
      });
    }

    // ✅ TIKTOK EVENT (safe check)
    if (typeof window !== "undefined" && window.ttq) {
      window.ttq.track("CompleteRegistration", {
        content_type: "user_signup",
        value: 1,
        currency: "USD"
      });
    }

    // Redirect to verify page
    navigate("/verify-email", { state: { email } });

  } catch (err) {
    setMessage(err.message);
  }
};


const handleLogin = async () => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);

    // Force refresh user data
    await result.user.reload();

    const refreshedUser = auth.currentUser;

    // 🧠 IMPORTANT: double-check verification safely
    if (!refreshedUser || !refreshedUser.emailVerified) {
      setMessage("Please verify your email before logging in.");
      return;
    }

    // ✅ Firebase Analytics
    if (analytics) {
      logEvent(analytics, "login", {
        method: "email"
      });
    }

    // ✅ Clean redirect
    navigate("/");

  } catch (err) {
    setMessage(err.message);
  }
};

const handlePasswordReset = async () => {

  try {

    await sendPasswordResetEmail(auth, resetEmail)

    alert("Password reset email sent. Check your inbox.")

    setShowReset(false)
    setResetEmail("")

  } catch (error) {

    alert("Error sending reset email: " + error.message)

  }

}



  return (
  <>
    <Helmet>
      <title>Login | EmployPilot</title>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>

    <div className="auth-wrapper">
      <div className="auth-left">
        <h1 className="auth-title">Welcome to EmployPilot ✨</h1>

        <p className="auth-tagline">
          Your career-boosting AI platform for resume writing, job prep,
          community guidance, and professional growth.
        </p>

        <ul className="auth-benefits">
          <li>⚡ AI-Powered Resume Builder</li>
          <li>💬 Pro Community & Career Forums</li>
          <li>🤖 AI Interview Coach & Career Advisor</li>
          <li>📄 Unlimited PDF Downloads</li>
          <li>🚀 Everything you need to level up your career</li>
        </ul>
      </div>

      <div className="auth-box">
        <h2>{mode === "login" ? "Log Into Your Account" : "Create Your Account"}</h2>
        {mode === "signup" && (
  <input
    type="text"
    placeholder="Choose a username"
    value={username}
    onChange={(e) => setUsername(e.target.value)}
    className="auth-input"
  />
)}

        <input 
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
        />

        <input 
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
        />

        {message && <p className="auth-message">{message}</p>}

{mode === "login" ? (
  <>
    <button className="auth-btn" onClick={handleLogin}>Log In</button>

    <p className="forgot-link" onClick={() => setShowReset(true)}>
      Forgot your password?
    </p>

    {showReset && (
      <div className="reset-box">

        <h3>Reset Password</h3>

        <p>
          Enter your email and we’ll send a password reset link.
        </p>

        <input
          type="email"
          placeholder="Enter your email"
          value={resetEmail}
          onChange={(e) => setResetEmail(e.target.value)}
        />

        <button onClick={handlePasswordReset}>
          Send Reset Link
        </button>

        <button onClick={() => setShowReset(false)}>
          Cancel
        </button>

      </div>
    )}

    <p className="auth-switch">
      Don’t have an account? <span onClick={() => setMode("signup")}>Sign up</span>
    </p>
  </>
) : (
  <>
    <button className="auth-btn" onClick={handleSignup}>Create Account</button>

    <p className="auth-switch">
      Already have an account? <span onClick={() => setMode("login")}>Log in</span>
    </p>
  </>
)}
      </div>
    </div>
  </>
  );

}

export default AuthPage;
